import { getOriginAndDestinarionAirports, getRegionValue } from '../../../../utilities/helpers';

export default (pnrInfo) => {
  const { 
    inboundArrivalDate,
    inboundDepartureDate,
    outboundDepartureDate, 
    outboundArrivalDate, 
  } = pnrInfo?.getAllOutboundAndInboundDates();

  const { 
    origin, 
    destination,
  } = getOriginAndDestinarionAirports(pnrInfo); 

  const legCollections = pnrInfo?.legCollection;
  const isInternationalFlight = pnrInfo?.legCollection?.some(legs => legs?.marketFlight !== 'DOMESTIC');
  let zone = isInternationalFlight ? 'INT' : 'DOM';
  const marketSegment = pnrInfo?.getAllMarketSegment();  
  let region = getRegionValue(legCollections?.[0]?.marketFlight, legCollections?.[0]?.regionKey, legCollections?.[0]?.legRegion);
  const tripType = pnrInfo?.flightItineraryType === 'ONEWAY' ? 'OW' :
    pnrInfo?.flightItineraryType === 'ROUNDTRIP' ? 'RT' : 'MC';
  
  let marketOd = `${origin}${destination}`;
  let marketNdod = sortAlphabetically(origin, destination);
  function sortAlphabetically(arrival, departure) {
    if (arrival < departure) {
      return `${arrival}${departure}`;
    }
    return `${departure}${arrival}`;
  }
  
  if (tripType === 'MC') {
    region = (legCollections || []).map(leg => {
      return getRegionValue(leg?.marketFlight, leg?.regionKey, leg?.legRegion);
    }).join('-');
    
    zone = (legCollections || []).map(leg => {
      return leg?.marketFlight !== 'DOMESTIC' ? 'INT' : 'DOM';
    }).join('-');

    marketNdod = [];
    marketOd = (legCollections || []).map(legs => {
      const segmentCollection = legs?.segmentsCollection || [];
      const segmentOrigin = segmentCollection?.[0]?.departureAirport || 'NA';
      const segmentDestination = segmentCollection?.slice(-1)?.[0]?.arrivalAirport || 'NA';
      marketNdod.push(sortAlphabetically(segmentOrigin, segmentDestination));
      return `${segmentOrigin}${segmentDestination}`;
    }).join('-');
  }
  
  return {
    event: 'selected_car',
    'funnel_name': 'MYB',
    'sub_funnel_name': 'car_rental',
    'outbound_departure_date': tripType === 'MC' ? outboundDepartureDate?.join('-') : outboundDepartureDate,
    'inbound_departure_date': inboundDepartureDate,
    'outbound_arrival_date': tripType === 'MC' ? outboundArrivalDate?.join('-') : outboundArrivalDate,
    'inbound_arrival_date': inboundArrivalDate,
    'origin': origin,
    'destination': destination,
    'trip_type': tripType,
    'market_od': marketOd,
    'market_ndod': tripType === 'MC' ? marketNdod.join('-') : marketNdod,
    'market_segment': marketSegment,
    'zone': zone,
    'region': region,
    'pnr': pnrInfo?.pnrCode,
  };
};